import { SearchOrganization } from "../../../../store/slices/GlobalSearchSlice";
import PersonsIcon from "../../../../assets/PersonsIcon";
import RowsIcon from "../../../../assets/RowsIcon";

interface OrgResultRowProps {
    org: SearchOrganization;
    onClick: (org: SearchOrganization) => void;
}

const OrgResultRow = ({ org, onClick }: OrgResultRowProps) => {
    return (
        <div
            onClick={() => onClick(org)}
            className="flex items-center justify-between h-[72px] px-6 border-b border-shadowborder cursor-pointer hover:bg-gray-50 transition-colors"
        >
            <p className="text-sm font-medium text-texthead">{org.displayName}</p>
            <div className="flex items-center gap-3">
                {/* Active Users */}
                <div className="flex items-center gap-1 border border-brColor rounded-full px-3 py-2 shadow-light-sm">
                    <PersonsIcon />
                    <span className="text-sm font-medium text-texthead">
                        {org.activeUsers || "-"}
                    </span>
                </div>
                {/* Sub Orgs */}
                <div className="flex items-center gap-1 border border-brColor rounded-full px-3 py-2 shadow-light-sm">
                    <RowsIcon />
                    <span className="text-sm font-medium text-texthead">
                        {org.activeSubOrgs || "-"}
                    </span>
                </div>
            </div>
        </div>
    );
};

export default OrgResultRow;
